import React, { memo } from "react";
import { Box, Text, Flex, Link, VStack, HStack } from "@chakra-ui/react";
import { Link as RouterLink } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Box bg="gray.800" width="full" py={6} mt="auto">
      <Flex 
        direction={{ base: "column", md: "row" }} 
        maxW="1200px"
        mx="auto"
        px={4}
        justify="space-between"
        align={{ base: "center", md: "flex-start" }}
        color="white"
        gap={6}
      >
        <VStack align={{ base: "center", md: "flex-start" }} spacing={2}>
          <Text fontWeight="bold" fontSize="lg">InfoFlow</Text>
          <Text fontSize="sm" color="gray.400">信息聚合平台</Text>
        </VStack>
        
        <HStack spacing={6} align="flex-start">
          <VStack align="flex-start" spacing={2}>
            <Text fontWeight="bold" mb={2}>导航</Text>
            <Link as={RouterLink} to="/" fontSize="sm" color="gray.400" _hover={{ color: "white" }}>首页</Link>
            <Link as={RouterLink} to="/category/AI行业" fontSize="sm" color="gray.400" _hover={{ color: "white" }}>AI行业</Link>
            <Link as={RouterLink} to="/category/加密货币" fontSize="sm" color="gray.400" _hover={{ color: "white" }}>加密货币</Link>
          </VStack>
          
          <VStack align="flex-start" spacing={2}>
            <Text fontWeight="bold" mb={2}>About</Text>
            <Link as={RouterLink} to="/about" fontSize="sm" color="gray.400" _hover={{ color: "white" }}>About Us</Link>
            <Link as={RouterLink} to="/debug/edge-function" fontSize="sm" color="gray.400" _hover={{ color: "white" }}>Admin</Link>
          </VStack>
        </HStack>
      </Flex>
      
      <Flex 
        borderTop="1px solid" 
        borderColor="gray.700"
        maxW="1200px"
        mx="auto"
        px={4}
        pt={4}
        mt={4}
        justify="center"
        color="gray.500"
      >
        <Text fontSize="sm">© {currentYear} InfoFlow. <Box as="span">Built with AI.</Box></Text>
      </Flex>
    </Box>
  );
};

export default memo(Footer);
